import React, { useEffect, useState } from "react";
import './style.css';
import { Layout, Spin, Select, Breadcrumb, Table, Button, Space, Form, Input, Row, Col, Divider, Card } from 'antd';
import Container from '../../Layout/Container';
import { Wizard, Steps, Step } from 'react-albus';
import { useLocation, Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import {
  SyncOutlined
} from "@ant-design/icons";
import { getProcess, viewProcessSelector, clearState } from './viewTemplateSlice';
const { Header, Content, Footer } = Layout;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

export default function ViewTemplate() {

  const dispatch = useDispatch();
  const location = useLocation();
  const [isToast, setToast] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [viewProcessData, setDataSource] = useState([]);

  const { isFetching, isSuccess, isError, errorMessage, viewProcess } = useSelector(
    viewProcessSelector
  );


  useEffect(() => {

    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(getProcess(location.state.tempId));
  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);

      toast.error(errorMessage);

    }
    if (isSuccess) {
      setLoading(false);
      setDataSource(viewProcess);
    }
  }, [isError, isSuccess, setLoading, viewProcess, setDataSource]);

  return (
    <>
      <Container>
        <Breadcrumb style={{ margin: '16px 0', paddingLeft: 50, marginBottom: 0 }} separator=">">
          <Breadcrumb.Item><Link to="/manage-seen-stamp">Manage Seen Stamp</Link></Breadcrumb.Item>
          <Breadcrumb.Item>View Seen Stamp</Breadcrumb.Item>
        </Breadcrumb>

        <div className="site-layout-content" style={{ marginTop: 0, paddingTop: 0 }}>

          <div style={{ padding: 24, paddingTop: 16 }}>
            <Wizard>
              <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isFetching} />
              <div>
                <Row style={{ backgroundColor: '#ffffff', paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                  <Col span="6"></Col>
                  <Col span="11" >
                    <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>Seen Stamp Preview</h1>
                  </Col>
                  <Col span="5" style={{ paddingLeft: 25 }}>
                    {/* <Button type="primary" shape="round" size="small"  style={{fontWeight:'bold'}}>STEP 3/3</Button> */}
                  </Col>
                </Row>

                <Row style={{ backgroundColor: '#ffffff', paddingTop: 10, paddingBottom: 80, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                  <Col span={24}>
                    <Row style={{ paddingTop: 15, paddingBottom: 15 }}>
                      <Col span="6"></Col>
                      <Col span={18}><h2 style={{ color: '#000000', fontSize: '16px' }}>Seen Stamp Details</h2></Col>
                    </Row>
                  </Col>
                  {/* <Col span="7"></Col>
                  <Col span="17"  > */}
                  <Col span="24">
                    <Form
                      layout="vertical"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      className="new-template-process-detail-box"
                    >
                      <Form.Item label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Seen Stamp Name*</p>}  >

                        <h3>{viewProcessData && viewProcessData.processName}</h3>
                      </Form.Item>
                      <Form.Item
                        label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 0 }}>Seen Stamp Description</p>}
                      >
                        <h3>{viewProcessData && viewProcessData.processSubject}</h3>
                      </Form.Item>
                      {/* <Form.Item label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,width:'100%'}}>Do you want to seen stamp for this process?</p>}  > */}
                      {/* <Input className="formInput" placeholder="Cadet Recruitment Process" /> */}
                      {/* <h3>Yes</h3> */}
                      {/* </Form.Item> */}
                    </Form>
                  </Col>
                  <Col span={24}>
                    <Row style={{ paddingTop: 30, paddingBottom: 0 }}>
                      <Col span="6"></Col>
                      <Col span={18}><h2 style={{ color: '#000000', fontSize: '16px' }}>Define Roles and Appointment</h2></Col>
                    </Row>
                  </Col>
                  {/* <Col span={7}></Col> */}
                  <Col span={24}>
                    {viewProcessData && viewProcessData.stage && viewProcessData.stage.map((process, key) => {
                      return (<>

                        <Form
                          layout="vertical"
                          labelCol={{ span: 10 }}
                          wrapperCol={{ span: 15 }}
                          key={key}
                        >
                          <div className="new-template-process-detail-box" style={{ marginBottom: 20 }}>
                            <Form.Item >
                              <Col span={6} style={{ textAlign: 'center' }}>
                                <h2 style={{ fontWeight: '400', fontStyle: 'normal', fontSize: 20, marginBottom: 0, color: "#ffffff", padding: '7px 10px', background: '#138AE6', borderRadius: '5px' }}>Stage #{process && process.stage} </h2>
                              </Col>
                              <Col span={18}>

                              </Col>

                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0 }}>

                              <Form.Item
                                className={'stage2FormItem'}
                                style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Department</p>}  >
                                {/* <Input className="formInput"  placeholder="" /> */}
                                <h3>{process && process.department}</h3>
                              </Form.Item>

                              <Form.Item
                                className={'stage2FormItem'}
                                style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                label={<Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Type</p></Col><Col style={{ textAlign: 'right' }} span={6}></Col></Row>}
                              >
                                {/* <Input className="formInput" placeholder="" /> */}
                                <h3>{process && process.departmentType}</h3>
                              </Form.Item>

                            </Form.Item>

                            <Form.Item style={{ marginBottom: 0 }}>
                              <Form.Item
                                className={'stage2FormItem'}
                                style={{ display: 'inline-block', width: process.departmentType == 'Branch' ? 'calc(50% - 8px)' : '80%' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}> {process.departmentType}</p>}  >
                                <h3>{process && process.departmentTypeName}</h3>
                              </Form.Item>
                              {process.departmentType == 'Branch' && process.directorateWithinBranch &&
                                <Form.Item
                                  className={'stage2FormItem'}
                                  style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                  label={<Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}> Directorate</p></Col><Col style={{ textAlign: 'right' }} span={6}></Col></Row>}
                                >
                                  <h3>{process && process.directorateWithinBranch}</h3>
                                </Form.Item>
                              }

                            </Form.Item>

                            {process && process.users && process.users.map((item, key) => {
                              let d = item.responseTime.day;
                              if (d.toString().length == 1) {
                                d = "0" + d;
                              }
                              let t = item.responseTime.time;
                              let rstime = d + ':' + t;
                              let responseTime = rstime.split(":");
                              return (
                                <>

                                  <Form.Item style={{ marginBottom: 0 }}>
                                    <Form.Item
                                      className={'stage2FormItem'}
                                      style={{ display: 'inline-block', width: 'calc(50% - 8px)' }} label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>APPT 1</p>}  >
                                      <h3>{item && item.username.name}</h3>
                                    </Form.Item>

                                    {/* <Form.Item
                                      className={'stage2FormItem'}
                                      style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                      label={<Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Response Time</p></Col><Col style={{ textAlign: 'right' }} span={6}></Col></Row>}
                                    >

                                      <h3>{responseTime[0] && responseTime[0] > 1 ? responseTime[0] + ' Days' : responseTime[0] + ' Day'} {responseTime[1] && responseTime[1] > 1 ? responseTime[1] + ' Hrs' : responseTime[1] + ' Hr'} {responseTime[2] && responseTime[2] > 1 ? responseTime[2] + ' Min' : responseTime[2] + ' Min'} {responseTime[3] && responseTime[3] > 1 ? responseTime[3] + ' Sec' : responseTime[0] + ' Sec'}</h3>
                                    </Form.Item> */}

                                  </Form.Item>

                                </>
                              );
                            })}

                          </div>
                        </Form>



                      </>);
                    })}

                  </Col>
                </Row>


              </div>

            </Wizard>

          </div>

        </div>
      </Container>
    </>
  );
}
